import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Plan } from '../model/plan.model';
import { PlanUserSummaryState } from '../state/plan-state';


const getplanState = createFeatureSelector<Plan>('plan');

export const getItem = createSelector(
    getplanState,
    state => state.itemId
);
export const getPlanIndex = createSelector(
    getplanState,
    state => state.planIndex
);
export const getIsPlanViewMode = createSelector(
    getplanState,
    state => state.IsPlanViewMode
);
const getPlanSummaryInfo = createFeatureSelector<PlanUserSummaryState>('planSummary');
export const planSummarySelector = createSelector(
    getPlanSummaryInfo,
    state => state
);

